import { render, staticRenderFns } from "./EditGradeCategory.vue?vue&type=template&id=1e9b4d53&scoped=true"
import script from "./EditGradeCategory.vue?vue&type=script&lang=js"
export * from "./EditGradeCategory.vue?vue&type=script&lang=js"
import style0 from "./EditGradeCategory.vue?vue&type=style&index=0&id=1e9b4d53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9b4d53",
  null
  
)

export default component.exports